var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetInfoAsync as InvokeAsync , GetInfoSync as InvokeSync}

async function GetInfoAsync(LoginToken,DeviceUUID)
{
    var GetInfoPromise = new Promise((resolve, reject) => {
        GetInfoSync(LoginToken,DeviceUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetInfoPromise;
}

function GetInfoSync(LoginToken,DeviceUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Device/GetInfo',                
        data  : {
            DeviceUUID   : DeviceUUID  ,
            LoginToken   : LoginToken  ,
            AppID        : KEYS.AWS_APPID              
        }                                    
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
